import { type InsuranceRenewalDetails } from '../../../pages/car-valuation/[registration]/[mileage]';

export type UseCarValuationProps = {
  insuranceRenewalDetails?: InsuranceRenewalDetails;
  registration: string;
};

const useCarValuation = (props: UseCarValuationProps) => {
  const { insuranceRenewalDetails, registration } = props;

  const normaliseRegistration = (registration: string) => {
    return registration.toLowerCase();
  };

  const getCurrentInsuranceRenewalMonth = () => {
    if (insuranceRenewalDetails?.currentRegistration) {
      if (
        normaliseRegistration(insuranceRenewalDetails?.currentRegistration) ===
        normaliseRegistration(registration)
      ) {
        return insuranceRenewalDetails?.insuranceRenewalMonth;
      }
    }
  };

  return {
    getCurrentInsuranceRenewalMonth,
  };
};

export { useCarValuation };
